<!-- src/components/NetworkStatus.vue -->
<template>
  <div class="p-4 max-w-md mx-auto text-center">
    <div
      class="p-4 rounded-md shadow-md"
      :class="
        isOnline ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'
      "
    >
      <p v-if="isOnline" class="font-semibold">You are currently online!</p>
      <p v-else class="font-semibold">
        You are currently offline. Please check your network connection.
      </p>
    </div>
  </div>
</template>

<script>
import { useNetwork } from "@vueuse/core";

export default {
  setup() {
    const { isOnline } = useNetwork();
    return { isOnline };
  },
};
</script>

<style scoped>
/* Add any additional styles if needed */
</style>
